import checkmarkUrl from "../img/checkmark.svg";
import xmarkUrl from "../img/xmark.svg";

// Per-question feedback: the correct/incorrect badge and mark image
export function showRightAnswer(index: number): void {
  const feedback = document.querySelector(`#q${index}Feedback`)!;
  feedback.textContent = "Correct!";
  feedback.className = "badge bg-success mt-2";
  setMarkImage(index, checkmarkUrl, "Checkmark");
}

export function showWrongAnswer(index: number): void {
  const feedback = document.querySelector(`#q${index}Feedback`)!;
  feedback.textContent = "Incorrect!";
  feedback.className = "badge bg-danger mt-2";
  setMarkImage(index, xmarkUrl, "X mark");
}

function setMarkImage(index: number, imageUrl: string, altText: string): void {
  const markContainer = document.querySelector(`#markImg${index}`)!;
  markContainer.textContent = "";

  const img = document.createElement("img");
  img.src = imageUrl;
  img.alt = altText;
  img.width = 24;
  img.className = "me-2";
  markContainer.appendChild(img);
}
